var _ = require('underscore');
var DateTimeUtil = require('DateTimeUtil');
var Marionette = require('marionette');

var Layout = Marionette.View.extend({
    regions: {
        activities: '#activities'
    },
    template: '#recordActivities'
});

var Activity = Marionette.View.extend({
    template: '#recordActivity',
    ui: {
        creator: '#creator'
    },
    onRender: function () {
        var activityDate = this.model.get('date');
        var activityDateString = _.isDate(activityDate) ? activityDate.toISOString() : activityDate;
        var dateString = new Date(activityDate).format();
        var ampmTime = DateTimeUtil.convertToAmPm(activityDateString, 'UTC');
        this.ui.creator.text(this.model.get('givenName') + ' | ' + this.model.get('role') + ' | ' + dateString + ', '+ ampmTime);
    }
});

var Activities = Marionette.CollectionView.extend({
    childView: Activity
});

module.exports.start = function (options) {
    var activities = options.activities;
    var region = options.region;
    var layout = new Layout();

    region.show(layout);
    layout.getRegion('activities').show(new Activities({
        collection: activities
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordActivity.js